var map = {
	"./ficon.html": "b3f9",
	"./logo1.1.png": "6867",
	"./logo1.png": "a994",
	"./logo2.png": "76cb",
	"./logo4.html": "02dc",
	"./newlogo1.png": "d5c5",
	"./newlogo2.png": "075f",
	"./oldlogo1.png": "b196",
	"./oldlogo2.png": "3733"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ca8";